<template>
  <div class='sqs_con'>
    <div class='w_1200 text_center'>
      <h3>{{ $t('home.caldecottLicensees.title') }}</h3>
      <div class='text' v-html='$t("home.caldecottLicensees.desc")'></div>
      <div class='search_box'>
        <input v-model='keyWord' type='text' :placeholder='$t("home.caldecottLicensees.placeholder")' class='dis_ib ver_m'>
        <a href='javascript:void(0)' class='more more2' @click='query()'>{{ $t('home.caldecottLicensees.button') }}</a>
      </div>
      <div v-if='!detail.name && search' class='rel1'>{{ $t('home.caldecottLicensees.none') }}</div>
      <div v-if='search && detail.name' class='rel2 pos_r'>
        <img :src='illStar' width='650' alt='' class='bg'>
        <div class='tit text_left'>搜索结果：</div>
        <div class='rel_info'>
          <h4 class='text_center'><img :src='illAuthorizationUp' width='97' alt=''><p>{{ detail.name }}</p><img :src='illAuthorizationDown' width='97' alt=''></h4>
          <ul>
            <li>公司名称：<span class='fw600'>{{ detail.name }}</span></li>
            <li>授权日期：<span class='fw600'>{{ detail.date }}</span></li>
            <li>授权编号：<span class='fw600'>{{ detail.number }}</span></li>
            <li>业务范围：<span class='fw600'>{{ detail.scope }}</span></li>
          </ul>
        </div>
      </div>
      <img v-if='!detail.name || !search' class='img' :src='illBook2' width='250' height='500' alt=''>
    </div>
    <authorize-search-menu
      :detail='detail' :search='search' :show='isShowSearchMenu' :key-word='keyWord'
      @searchAuthorize='query' @close='reset'
    >
    </authorize-search-menu>
  </div>
</template>

<script>
import { setTitle, mediaDevice } from 'utils'
import illBook2 from '@/assets/icons/ill_book2@2x.png'
import illStar from '@/assets/icons/ill_star@2x.png'
import illAuthorizationUp from '@/assets/icons/ill_authorization_up@2x.png'
import illAuthorizationDown from '@/assets/icons/ill_authorization_down@2x.png'
import { queryPartners } from '@/service'
import AuthorizeSearchMenu from '@/components/AuthorizeSearchMenu'

export default {
  name: 'AuthorizeSearch',
  components: {
    AuthorizeSearchMenu,
  },
  data () {
    return {
      illBook2,
      illStar,
      illAuthorizationUp,
      illAuthorizationDown,
      keyWord: '',
      detail: {},
      search: false,
      isShowSearchMenu: false,
    }
  },
  beforeMount () {
    setTitle(`${this.$t('home.logo')} - ${this.$t('home.caldecottLicensees.title')}`)
  },
  methods: {
    query (q = this.keyWord) {
      // 设备为手机且菜单隐藏时点击仅出现菜单，其余情况进行搜多
      if (mediaDevice() == 'mobile' && !this.isShowSearchMenu) {
        document.body.className = 'fixed'
        this.isShowSearchMenu = true
        return
      }
      queryPartners({ q }).then(res => {
        this.search = true
        this.detail = res.data
      })
    },
    reset () {
      this.keyWord = ''
      this.detail = {}
      this.search = false
      document.body.className = ''
      this.isShowSearchMenu = false
    },
  },
}
</script>
